import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { pogCsvColumnsModalDataAtom, PogCsvColumnsModalData } from "./atoms";

export const usePogCsvColumnsModal = () => {
  const { openModal } = useModals();
  const setData = useSetAtom(pogCsvColumnsModalDataAtom);

  const openPogCsvColumnsModal = (data: PogCsvColumnsModalData) => {
    setData(data);
    openModal("PogCsvColumnsModal");
  };

  return { openPogCsvColumnsModal };
};
